export const IDLE_WARNING_MS = 2 * 60 * 1000;
export const IDLE_TICK_MS = 1000;
// Activity is persisted at most this often; other tabs read it on their next tick.
export const ACTIVITY_WRITE_THROTTLE_MS = 5000;
export const ACTIVITY_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'scroll'];
